import { render, staticRenderFns } from "./carbonEmission.vue?vue&type=template&id=19b9df89&scoped=true"
import script from "./carbonEmission.vue?vue&type=script&lang=js"
export * from "./carbonEmission.vue?vue&type=script&lang=js"
import style0 from "./carbonEmission.vue?vue&type=style&index=0&id=19b9df89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b9df89",
  null
  
)

export default component.exports